export const SNOWPLOW_JS_SOURCE = 'gitlab-javascript';
